import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { submitChangePassword } from '../../../Actions/Login.action';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import { translate } from '../../../Services/translation';
import Input from '../../Inputs/Input';
import clsx from 'clsx';
import EditorString from '../../EditorString/EditorString';

const LoginChangePassword = () => {
  const {
    isLoading,
    username = '',
    password = '',
    changePasswordMessage,
  } = useTypedSelector((state) => state.login);
  const [newPassword, setNewPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const dispatch = useDispatch();

  const onSubmit = (e?: any) => {
    if (e) {
      e.preventDefault();
    }
    dispatch(
      submitChangePassword(
        username,
        password,
        newPassword,
        passwordConfirmation
      )
    );
  };

  return (
    <>
      <div className="mb-6 flex flex-col gap-2">
        <h3 className="uppercase">{translate('login.change-password')}</h3>
        {changePasswordMessage?.value && (
          <EditorString
            value={changePasswordMessage?.value}
            className="text-lg"
          />
        )}
      </div>
      <form onSubmit={onSubmit} className={clsx('mt-6')}>
        <Input
          wrapperClassName={clsx('mb-4')}
          label={translate('general.password')}
          inputSize="large"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder={translate('general.password')}
          type="password"
          disabled={isLoading}
        />
        <Input
          label={translate('login.confirm-password')}
          inputSize="large"
          value={passwordConfirmation}
          onChange={(e) => setPasswordConfirmation(e.target.value)}
          placeholder={translate('login.confirm-password')}
          type="password"
          disabled={isLoading}
        />
        <button
          className={clsx(
            'btn',
            'btn--large',
            'btn--secondary',
            'w-full',
            'mt-6',
            'lg:mt-8'
          )}
          type="submit"
          disabled={isLoading}
        >
          {!isLoading && translate('general.send')}
          {isLoading && translate('general.loading')}
        </button>
      </form>
    </>
  );
};

export default LoginChangePassword;
